import { fadeInKeyframes } from '@/lib/css-lib';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import SpinImg from "@/assets/loading/spin.gif";
export interface SavingProps {
    message?: string
}

/**
 * 保存中の表示
 * @param props 
 */
const Saving: React.FC<SavingProps> = (props) => {

    const [rotCount, setRotCount] = useState(0);

    useEffect(() => {
        const id = setTimeout(() => {
            setRotCount((rotCount + 1) % 5);
        }, 500);

        return () => {
            clearTimeout(id);
        };
    }, [rotCount]);

    const text = props.message ?? `保存中`;

    return <Container>
        {/* <video className='videoTag' autoPlay loop muted>
            <source src={"/clip/books.mp4"} type='video/mp4' />
        </video> */}
        <Modal>
            <div className="text">
                {text}
            </div>
            <img src={SpinImg} alt="Please wait." />
        </Modal>
    </Container>;
}

export default Saving;

const Container = styled.div`
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(32, 32, 32, 0.6);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    animation: ${fadeInKeyframes} 0.3s linear;
    z-index: 99999;

`;

const Modal = styled.div`

    background-color: white;
    border-radius: 15px;
    border: 1px solid rgba(128, 128, 128, 0.5);
    width: 500px;
    padding: 20px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;    

    & > video {
        max-width: 300px;
        max-height: 300px;
    }

    & > .text {
        color: #707070;
        font-size: x-large;
        margin-top: 15px;
        white-space: pre-wrap;
        text-align: center;
    }
`;